<template>
  <TBadge
    variant="highlight"
    is-inverted
    :is-removable="isRemovable"
   
    @remove="removePromoCode"
  >
    {{ code }}
  </TBadge>
</template>

<script setup lang="ts">
defineProps<{
  code: string
  isRemovable?: boolean
}>()

const {
  removePromoCode,
} = usePromoCode()
</script>
